import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';

const DetailBook = () => {
  const { bookId, bookNameLower } = useParams();
  const [bookDetail, setBookDetail] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRef = useRef(null);

  // Pertahankan sesi terakhir (untuk satu buku)
  useEffect(() => {
    const allSessions = JSON.parse(localStorage.getItem('watchSessions')) || [];
    const lastSession = allSessions.find(session => session.bookId === bookId);

    if (lastSession) {
      setCurrentVideoIndex(lastSession.currentVideoIndex);
    } else {
      setCurrentVideoIndex(0);
    }
  }, [bookId]);

  // Ambil data detail buku dan chapter
  useEffect(() => {
    const fetchBookDetails = async () => {
      try {
        const response = await fetch(
          `https://www.dramaboxdb.com/_next/data/dramaboxdb_prod_20250114/in/movie/${bookId}/${bookNameLower}.json`
        );
        const data = await response.json();
        const { bookInfo, chapterList } = data.pageProps;

        const formattedChapters = chapterList.map((chapter) => {
          const originalCover = chapter.cover;
          const updatedCover = originalCover
            .replace('@w=100&h=135', '')
            .replace('.mp4.jpg', '.720p.narrowv3.mp4');

          return {
            indexStr: chapter.indexStr.slice(-3),
            videoUrl: updatedCover,
          };
        });

        setBookDetail({
          bookName: bookInfo.bookName,
          cover: bookInfo.cover,
          introduction: bookInfo.introduction,
          chapterCount: bookInfo.chapterCount,
          typeTwoName: bookInfo.typeTwoName,
          chapters: formattedChapters,
        });
      } catch (error) {
        console.error('Error fetching book details:', error);
      }
    };

    fetchBookDetails();
  }, [bookId, bookNameLower]);

  // Simpan sesi terbaru ke localStorage
  useEffect(() => {
    if (bookDetail) {
      const lastSession = {
        bookId,
        bookNameLower,
        bookName: bookDetail.bookName,
        currentVideoIndex,
        timestamp: new Date().toISOString(),
      };

      localStorage.setItem('lastWatchSession', JSON.stringify(lastSession));

      const allSessions = JSON.parse(localStorage.getItem('watchSessions')) || [];
      const updatedSessions = allSessions.filter(session => session.bookId !== bookId);
      updatedSessions.push(lastSession);

      localStorage.setItem('watchSessions', JSON.stringify(updatedSessions));
    }
  }, [bookDetail, bookId, bookNameLower, currentVideoIndex]);

  const handleVideoChange = (index) => {
    setCurrentVideoIndex(index);
    if (videoRef.current) {
      videoRef.current.load();
    }
  };

  const handleVideoEnd = () => {
    if (currentVideoIndex < bookDetail.chapters.length - 1) {
      setCurrentVideoIndex((prevIndex) => prevIndex + 1);
    }
  };

  // Pastikan bookDetail sudah ada sebelum render
  if (!bookDetail) {
    return <Typography>Loading...</Typography>;
  }

  const currentVideo = bookDetail.chapters[currentVideoIndex]?.videoUrl;

  return (
    <Box sx={{ padding: 2 }}>
      {/* Pemutar Video - Paling atas */}
      {currentVideo && (
        <Box sx={{ marginBottom: 2 }}>
          <video
            ref={videoRef}
            src={currentVideo}
            controls
            autoPlay
            onEnded={handleVideoEnd}
            style={{ width: '100%', maxHeight: '400px', borderRadius: '8px' }}
          />
        </Box>
      )}

      {/* Bagian Gambar Buku dan Tombol Episode */}
      <Grid container spacing={1} sx={{ marginBottom: 2 }}>
        {/* Tombol Episode - Sebelah Kanan Gambar */}
        <Grid item xs={12} sm={8}>
          <Grid container spacing={1}>
            {bookDetail.chapters.map((chapter, index) => (
              <Grid item key={index} xs={3} sm={2}>
                <Button
                  variant={currentVideoIndex === index ? 'contained' : 'outlined'}
                  fullWidth
                  onClick={() => handleVideoChange(index)}
                >
                  {chapter.indexStr}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <CardMedia
            component="img"
            sx={{ width: '100%', height: 'auto', borderRadius: '8px' }}
            image={bookDetail.cover}
            alt={bookDetail.bookName}
          />
        </Grid>
      </Grid>

      {/* Bagian Keterangan Buku (Detail) */}
      <Box sx={{ marginTop: 2 }}>
        <Typography variant="body2">{bookDetail.introduction}</Typography>
      </Box>
    </Box>
  );
};

export default DetailBook;
